import Pusher from "pusher-js";
import {PUSHER_WHATSAPP_KEY} from "../common";
import {getLoggedInUserName} from "../screen/TicketListingScreen/helper";
import NotificationToast from "./component/NotificationToastComponent";
import React from "react";
import {toast} from "react-toastify";

// Do not set this in Production
Pusher.logToConsole = false;

export const pusher = new Pusher(PUSHER_WHATSAPP_KEY, {
    cluster: "ap2",
    forceTLS: true
});
let isSubscribed = false;

const handleNewMessage = (newMessage) => {
    // alert("New Message");
    toast(
        <NotificationToast
            message={newMessage.data.text}
            mobileNumber={newMessage.data.mobile_number}
        />, {
            autoClose: false
        }
    );
}

export const unsubscribePusher = () => {
    const username = getLoggedInUserName();
    if (!username) {
        return true;
    }
    pusher.unsubscribe("whatsapp-agent-"+username);
    isSubscribed = false;
}

export const subscribePusher = () => {
    if (!isSubscribed) {
        const username = getLoggedInUserName();
        if (!!username) {
            const chatChannel = pusher.subscribe("whatsapp-agent-" + username);
            chatChannel.bind("pusher:subscription_succeeded", () => {
                chatChannel.bind("message_received", (newMessage) => {
                    handleNewMessage(newMessage);
                });
            });
            isSubscribed = true;
        }
    }
}

export default pusher;